module.exports = __webpack_public_path__ + "static/media/Inbox.6b9cf926.svg";